module.exports = __webpack_public_path__ + "media/images/front/premium_lp/btn_01-73632f4603444f799eebbe1eb1960e7a.png";